import { styled } from "sharedUI/styles";
import { Wrapper } from "../modal-provider/modal-provider-style";

export const ModalWrapper = styled(Wrapper)`
    padding: 48px 48px 32px;
    box-shadow: 0px 36px 42px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    display: flex;
    flex-direction: column;

    @media only screen and (max-width: 700px) {
        width: 80vw;
        height: auto;
    }
`;

export const GlideLogoWrapper = styled.div`
    margin: 0 0 36px;
    max-width: 110px;

    color: ${p => p.theme.textDark};

    svg {
        width: 100%;
    }
`;

export const Content = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .email-region {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .link {
        color: ${p => p.theme.g500};
    }

    .form-input {
        margin-bottom: 16px;
        padding: 14px 20px;
        width: 100%;
        background-color: ${p => p.theme.formControlBg};
        border-radius: 10px;
        box-shadow: none;
        color: ${p => p.theme.fgColorDark};
        font-size: 16px;
        transition: all ${p => p.theme.transitionBase};

        &:hover {
            background-color: ${p => p.theme.formControlBgHover};
        }

        &:focus {
            background-color: ${p => p.theme.bgFront};
            box-shadow: 0 0 0 2px ${p => p.theme.g400};
        }
    }

    .or-bar {
        display: flex;
        align-items: center;
        width: 100%;
        margin: 24px 0;
        color: ${p => p.theme.textXpale};
        font-size: 10px;
        font-weight: 500;
        text-transform: uppercase;

        .or-bar-bar {
            height: 1px;
            background-color: ${p => p.theme.borderXpale};
            flex-grow: 1;
            margin: 0 6px;
        }
    }

    color: ${p => p.theme.fgColorDark};
    font-size: 16px;
`;

export const MainButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 12px 20px;
    background-color: ${p => p.theme.accentSecondary};
    border-radius: 10px;
    box-shadow: ${p => p.theme.shadow1};
    color: ${p => p.theme.textInverse};
    font-size: 16px;
    font-weight: 500;
    transition: all ${p => p.theme.transitionBase};
    cursor: pointer;

    svg {
        overflow: visible;
    }

    &:hover {
        box-shadow: ${p => p.theme.shadow3};
    }

    &.secondary {
        background-color: ${p => p.theme.n0};
        color: ${p => p.theme.textBase};

        &:hover {
            box-shadow: ${p => p.theme.shadow3};
            color: ${p => p.theme.textDark};
        }
    }
`;

export const IconWrapper = styled.div`
    width: 24px;
    height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    line-height: 0;
`;

export const GDPRConsentWrapper = styled.div`
    display: flex;
    margin-top: 24px;
    color: ${p => p.theme.textPale};
    font-size: 12px;
    text-align: center;
    cursor: pointer;

    input {
        appearance: checkbox;
        margin-right: 8px;
    }
`;

export const LegalText = styled.div`
    margin: 16px 0;
    color: ${p => p.theme.textPale};
    font-size: 12px;
    text-align: center;

    a {
        text-decoration: underline !important;
    }

    a:hover {
        text-decoration: underline !important;
        color: ${p => p.theme.b400};
    }
`;

export const Footer = styled.div`
    margin: 24px 0 0;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    a {
        display: block;
        text-align: center;
        padding: 12px;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 500;
        color: ${p => p.theme.g500};
        transition: all ${p => p.theme.transitionBase};

        :hover {
            background-color: ${p => p.theme.g100};
            text-decoration: underline;
        }
    }
`;
